module.exports = __webpack_public_path__ + "img/orden_listado_seleccionado.a9e9eae8.png";